import React from 'react';
import PropTypes from 'prop-types';

import './toggle-switch.scss';

export const ToggleSwitch = ({
  id,
  did,
  name,
  checked,
  onChange,
  optionLabels,
  small,
  disabled,
  noLabels,
}) => {
  return (
    <div
      className={
        'toggle-switch' +
        (small ? ' small-switch' : '') +
        (noLabels ? ' no-labels' : '')
      }
    >
      <input
        type="checkbox"
        name={name}
        className="toggle-switch-checkbox"
        id={id}
        data-id={did}
        checked={checked}
        onChange={(e) => onChange(e)}
        disabled={disabled}
      />
      {id ? (
        <label className="toggle-switch-label" htmlFor={id}>
          <span
            className={
              disabled
                ? 'toggle-switch-inner toggle-switch-disabled'
                : 'toggle-switch-inner'
            }
            data-yes={optionLabels[0]}
            data-no={optionLabels[1]}
          />
          <span
            className={
              disabled
                ? 'toggle-switch-switch toggle-switch-disabled'
                : 'toggle-switch-switch'
            }
          />
        </label>
      ) : null}
    </div>
  );
};

ToggleSwitch.defaultProps = {
  optionLabels: ['Yes', 'No'],
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  did: PropTypes.number,
  optionLabels: PropTypes.array,
  small: PropTypes.bool,
  disabled: PropTypes.bool,
};
